import Aws from 'aws-sdk'
import Uuid from 'uuid/v4'
import _ from 'lodash'
import Moment from 'moment'

function preset() {
  return {
    tasksQueueUrl: 'https://sqs.ap-northeast-1.amazonaws.com/270961102979/lightfile-simulator-tasks',
    simulationsTable: 'Simulations',
    resourceUrlBase: 'https://s3-ap-northeast-1.amazonaws.com/sim.lightfile.net/',
    i18n: {
      simulations: {
        webp: 'WebPに変換',
        orig: 'オリジナル画像データ',
      },
      types: {
        webp: 'WebP',
        jpeg: 'Jpeg',
        jpg: 'Jpeg',
        png: 'PNG',
        gif: 'GIF',
        lightfile: '画像軽量化済み',
        not: '軽量化未対応',
      },
    },
    colors: {
      types: {
        jpeg: '#56a0e5',
        jpg: '#56a0e5',
        png: '#ed6d85',
        gif: '#f7cf6b',
        webp: '#6cbebf',
        lightfile: '#cccccc',
        not: '#cccccc',
      },
    },
  }
}

class Report {
  constructor(values = {}) {
    Object.assign(this, values)
  }

  static reportForIntent(intent) {
    if (intent == 'lightfile') {
      return new this({
        types: ['lightfile', 'jpg', 'png'],
        simulations: ['high', 'medium', 'low'],
      })
    } else if (intent == 'already') {
      return new this({
        types: ['not', 'jpg', 'png'],
        simulations: ['orig', 'before'],
      })
    } else if (intent == 'after') {
      return new this({
        types: ['not', 'jpg', 'png'],
        simulations: ['orig', 'after'],
      })
    } else if (intent == 'lightfileonly') {
      return new this({
        types: ['lightfile', 'jpg', 'png', 'webp'],
        simulations: ['orig', 'low'],
      })
    } else if (intent == 'lightfilewebp') {
      return new this({
        types: ['webp', 'jpg', 'png', 'gif'],
        simulations: ['orig', 'lightfile', 'webp'],
      })
    }
  }
}

class App {
  constructor(values = {}) {
    Object.assign(this, values)
  }

  awsParams(params) {
    return _.defaults(params, {
      accessKeyId: 'AKIAI4EONNN7LZP2PWWA',
      secretAccessKey: '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',
      region: 'ap-northeast-1',
    })
  }

  documentClient() {
    return new Aws.DynamoDB.DocumentClient(this.awsParams())
  }

  sqs() {
    return new Aws.SQS(this.awsParams())
  }

  async loadReport(id) {
    const docClient = this.documentClient()
    const data = await docClient
      .get({
        TableName: preset().simulationsTable,
        Key: {
          id,
        },
      })
      .promise()
    return data ? data.Item : undefined
  }

  async getQueuedTasks() {
    const sqs = this.sqs()
    const queue = await sqs
      .getQueueAttributes({
        QueueUrl: preset().tasksQueueUrl,
        AttributeNames: ['ApproximateNumberOfMessages', 'ApproximateNumberOfMessagesNotVisible'],
      })
      .promise()

    const waiting = parseInt(queue.Attributes.ApproximateNumberOfMessages || 0),
      processing = parseInt(queue.Attributes.ApproximateNumberOfMessagesNotVisible || 0)

    return {
      waiting,
      processing,
    }
  }

  async sendNewSimulationTask(simulation) {
    const task = {
      id: Uuid(),
      device: simulation.device,
      url: simulation.url,
      ip: simulation.ip,
      action: 'simulate',
      intent: simulation.intent || 'lightfile',
      vendor: 'ideamans',
      baseUrl: 'https://src.lightfile.net',
    }

    if (simulation.email) {
      task.email = {
        to: simulation.email,
        subject: 'LightFileシミュレーター {{label}}',
        text: `ご利用ありがとうございます。
レポートが作成されました。

- 対象ページ: {{label}}
- 対象URL: {{url}}
- 導入レポート: https://src.lightfile.net/v3/reports/${task.id}

またのご利用をお待ちしています。

📊 LightFile シミュレーター
https://src.lightfile.net/v3/`,
      }
    }

    if (simulation.label) {
      task.label = simulation.label
    }

    const sqs = this.sqs()
    await sqs
      .sendMessage({
        QueueUrl: preset().tasksQueueUrl,
        MessageBody: JSON.stringify(task),
      })
      .promise()

    return task
  }

  async sendNewPackTask(order) {
    const task = {
      action: 'pack',
      id: order.id,
      lang: 'ja',
      vendor: 'ideamans',
      baseUrl: 'https://src.lightfile.net',
      email: {
        to: order.email,
        subject: 'LightFileによる変換結果のダウンロード {{title}}',
        text: `ご利用ありがとうございます。
軽量化された画像のダウンロード準備が完了しました。

{{downloadUrl}}

- 対象ページ: {{title}}
- 対象ページのURL: {{url}}
- 変換レポート: https://src.lightfile.net/v3/reports/${order.id}

またのご利用をお待ちしています。

📊 LightFile シミュレーター
https://src.lightfile.net/v3/`,
      },
    }

    const sqs = this.sqs()
    await sqs
      .sendMessage({
        QueueUrl: preset().tasksQueueUrl,
        MessageBody: JSON.stringify(task),
      })
      .promise()

    return task
  }
}

class History {
  constructor(json, opts = {}) {
    this.records = []
    try {
      const records = JSON.parse(json)
      if (_.isArray(records)) this.records = records
    } catch (ex) {
      // do nothing
    }

    this.options = _.defaultsDeep(opts, {
      limit: 100,
      key: 'id',
    })
  }

  add(record) {
    const key = record[this.options.key]
    if (!_.isNil(key)) {
      this.records = this.records.filter((r) => r[this.options.key] !== key)
    }

    record.time = Moment().toISOString()
    this.records.unshift(record)
    if (this.records.length > this.options.limit) {
      this.records.splice(this.options.limit)
    }
  }

  serialize() {
    return JSON.stringify(this.records)
  }
}

export default {
  App,
  History,
  Report,
  preset,
}
